import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    Precio: "1000",
    Compra: [],
    Productos: [
      {
        nombre: "Optiplex DELL",
        precio: "1500000",
        idproducto: "1",
        img: "https://cdn11.bigcommerce.com/s-r4tr0/images/stencil/1280x1280/products/254849/394197/optiplex_9020usff__63715.1496935668.jpg?c=2&imbypass=on",
        descripcion: "Equipo de escritorio de alta calidad para toda su empresa",
        marca: "DELL",
        categoria: "Computadores",
        dimensiones: "",
        cantidad: "100",
      },
      {
        nombre: "OptiplexADS DELL",
        precio: "2500000",
        idproducto: "2",
        img: "https://cdn11.bigcommerce.com/s-r4tr0/images/stencil/1280x1280/products/254849/394197/optiplex_9020usff__63715.1496935668.jpg?c=2&imbypass=on",
        descripcion: "Equipo de escritorio de alta calidad para toda su empresa",
        marca: "DELL",
        categoria: "Computadores",
        dimensiones: "",
        cantidad: "100",
      },{
        nombre: "Optiplex DELL",
        precio: "1500000",
        idproducto: "1",
        img: "https://cdn11.bigcommerce.com/s-r4tr0/images/stencil/1280x1280/products/254849/394197/optiplex_9020usff__63715.1496935668.jpg?c=2&imbypass=on",
        descripcion: "Equipo de escritorio de alta calidad para toda su empresa",
        marca: "DELL",
        categoria: "Computadores",
        dimensiones: "",
        cantidad: "100",
      },{
        nombre: "Optiplex DELL",
        precio: "1500000",
        idproducto: "1",
        img: "https://cdn11.bigcommerce.com/s-r4tr0/images/stencil/1280x1280/products/254849/394197/optiplex_9020usff__63715.1496935668.jpg?c=2&imbypass=on",
        descripcion: "Equipo de escritorio de alta calidad para toda su empresa",
        marca: "DELL",
        categoria: "Computadores",
        dimensiones: "",
        cantidad: "100",
      },{
        nombre: "Optiplex DELL",
        precio: "1500000",
        idproducto: "1",
        img: "https://cdn11.bigcommerce.com/s-r4tr0/images/stencil/1280x1280/products/254849/394197/optiplex_9020usff__63715.1496935668.jpg?c=2&imbypass=on",
        descripcion: "Equipo de escritorio de alta calidad para toda su empresa",
        marca: "DELL",
        categoria: "Computadores",
        dimensiones: "",
        cantidad: "100",
      }

    ]
  },
  mutations: {
    increment(state, i) {
      state.Compra.push(i)
    },
    delete(state, i) {
      state.Compra.splice(i, 1)
    }
  },
  actions: {
  },
  modules: {
  }
})
